import { Modal, Box, Typography, Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

export default function ConfirmDeleteModal({ 
  open, 
  onClose, 
  onConfirm, 
  itemName 
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" gutterBottom>
          Хақиқатдан "{itemName}ни ўчиришни истаяпсизми"?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
          <Button 
            variant="contained" 
            color="error"
            onClick={onConfirm}
          >
            Ўчириш
          </Button>
          <Button 
            variant="outlined" 
            onClick={onClose}
          >
            Бекор қилиш
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}